import React from 'react'
import { Typography } from '@mui/material'
import { formatDateYYYYMMDD } from '../packages/utils/numberFormatters'

interface DateRangeProps {
    endDate?: string | null
    startDate?: string | null
}

function DateRange({ endDate, startDate }: DateRangeProps) {
    if (!endDate || !startDate) return null
    const formatedStartDate = formatDateYYYYMMDD(startDate)
    const formatedEndDate = formatDateYYYYMMDD(endDate)
    const isOneDayRange = formatedEndDate === formatedStartDate

    return (
        <Typography variant='caption' color='textSecondary' sx={{ fontVariantNumeric: 'tabular-nums' }}>
            {isOneDayRange && formatedStartDate}
            {!isOneDayRange && `${formatedStartDate} => ${formatedEndDate}`}
        </Typography>
    )
}

export default DateRange
